'use client';

import { useTranslations } from 'next-intl';
import {
  Conditional,
  HeaderStoreLocationButton
} from 'components/pcc-components';
import { useStoreInfoDrawer } from '../../store-info-drawer-context';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';
import usePathContains from 'hooks/use-path-contains';
import { CART_ROUTE } from 'constants/links';

interface StoreLocationButtonProps {
  isLoggedIn: boolean;
  isDealerUser: boolean;
}

export const StoreLocationButton = ({
  isLoggedIn,
  isDealerUser
}: StoreLocationButtonProps) => {
  const t = useTranslations();
  const storeInfoDrawer = useStoreInfoDrawer();
  const { associatedDealerDrawer } = useAssociatedDealer();
  const dealerLocatorDrawer = useDealerLocatorDrawer();
  const { checkPathHas } = usePathContains();

  const changeLocationLabel = t('MA_DROPDOWN_IA_CHANGE_STORE');

  const handleClick = () => {
    storeInfoDrawer.closeDrawer();
    isLoggedIn
      ? associatedDealerDrawer.openDrawer()
      : dealerLocatorDrawer.openDrawer();
  };

  return (
    <Conditional
      test={isDealerUser || (!checkPathHas(CART_ROUTE) && !checkPathHas('/confirmation'))}
      fallback={null}
    >
      <HeaderStoreLocationButton
        label={changeLocationLabel}
        onClick={handleClick}
      />
    </Conditional>
  );
};
